module.exports = __webpack_public_path__ + "img/base.ae745b1a.svg";